import React from 'react';
import { useNavigate } from 'react-router-dom';
export function ThankYouPage() {
  const navigate = useNavigate();
  return <main className="min-h-screen w-full bg-brand-bg text-brand-text font-sans flex flex-col items-center justify-center p-4 text-center" data-id="element-363">
      <h1 className="text-3xl md:text-4xl font-bold text-brand-gold mb-4" data-id="element-364">
        ¡Gracias por tu compra!
      </h1>
      <p className="text-brand-muted text-lg mb-8 max-w-md" data-id="element-365">
        Tu acceso al Método Sin-Tipster ya está listo. Revisa tu correo para los
        próximos pasos.
      </p>
      <button onClick={() => navigate('/')} className="text-brand-gold underline underline-offset-4 hover:text-brand-text transition-colors" data-id="element-366">
        Volver al inicio
      </button>
    </main>;
}